<template>
    <div class="floating__socials" v-bind:class="[floatingColors, hoverColor + '--hover']">

       <ul>
        <li><a target="_blank" href="https://www.facebook.com/intervi.co" rel="noopener">facebook</a></li>
        <li><a target="_blank" href="https://www.instagram.com/interactivevision/" rel="noopener">instagram</a></li>
        <li><a target="_blank" href="https://www.behance.net/intervi" rel="noopener">behance</a></li>
        <li><a target="_blank" href="https://dribbble.com/intervi" rel="noopener">dribbble</a></li>
      </ul>

    </div>

</template>

<script>
export default {
  name: "FloatingSocials",
  data() {
    return {};
  },
  props: ["floatingColors", "hoverColor"]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/FloatingSocials.vue